export const imageSlides = [
  {
    sourceImage:
      "https://i.ibb.co/PM9P8pc/Whats-App-Image-2021-11-21-at-22-14-02.jpg",
    title: "",
  },
  {
    sourceImage:
      "https://i.ibb.co/7Xb2zfw/Whats-App-Image-2021-11-22-at-20-05-38.jpg",
    title: "",
  },
  {
    sourceImage:
      "https://i.ibb.co/KbLNQ8h/Whats-App-Image-2021-11-21-at-22-19-05.jpg",
    title: "",
  },
];
